<template>
  <div class="wrp">
    <div class="money-wrp">
      <div class="title">
        <p>开票金额</p>
      </div>
      <van-cell-group v-show="moneyIptShow" :border="false" class="money">
        <div class="iconfont">&#xe60a;</div>
        <van-field
          type="number"
          v-model="applyData.money"
          ref="moneyIpt"
          maxlength="10"
          @blur="inputBlur"
          @focus="inputFocus"
        >
          <i v-if="applyData.money.length > 0" @click="clearMoney" class="iconfont clear" slot="button">&#xe60b;</i>
        </van-field>
      </van-cell-group>
      <div class="money money-value" v-if="!moneyIptShow">
        <div class="iconfont">&#xe60a;</div>
        <p @click="moneyValueHandle" v-if="applyData.money.length > 0">{{convertNumber(applyData.money)}}</p>
        <p @click="moneyValueHandle" class="please" v-if="!(applyData.money.length > 0)">请输入开票金额</p>
        <i v-if="applyData.money.length > 0" @click="clearMoney" class="iconfont clear" slot="button">&#xe60b;</i>
      </div>
     </div>
      <section>
        <div class="infomation-wrp">
          <div class="detail-list-wrp">
            <div class="detail-item">
              <span>开票日期</span>
              <span style="color: #000;">{{today}}</span>
            </div>
            <div class="detail-item">
              <span>发票备注</span>
              <div class="remark-input">
                <InputField
                  type="text"
                  :value="applyData.remark"
                  :maxlength="getIsAllElectric ? 200 : null"
                  placeholder="请输入发票备注信息"
                  :substrFn="handleSubstrFn"
                  @oninputchange="($event) => onInputChange({e: $event, field:'remark'})"
                  @onFocus="onFocus"
                />
              </div>
            </div>
            <div class="detail-item">
              <span>开票方式</span>
              <div class="select-invoice-type" @click="showInvoiceType = true">
                <span >{{getInvoiceType(applyData.invoiceType)}}</span>
                <span class="iconfont">&#xe60c;</span>
              </div>
            </div>
            <div class="detail-item" v-if="[7, 8].includes(applyData.invoiceType)">
              <span>特定业务</span>
              <div class="select-invoice-type" @click="showBusinessType = true">
                <span >{{getBusinessType(applyData.elementCode)}}</span>
                <span class="iconfont">&#xe60c;</span>
              </div>
            </div>
            <div class="detail-item">
              <span>订单编号</span>
              <div class="remark-input">
                <InputField
                  type="text"
                  :value="applyData.externalDocumentNo"
                  placeholder="请输入订单编号信息"
                  @oninputchange="($event) => onInputChange({e: $event, field:'externalDocumentNo'})"
                  @onFocus="onFocus"
                />
              </div>
            </div>
            <div class="detail-item">
              <span>单据附注</span>
              <div class="remark-input">
                <InputField
                  type="text"
                  :value="applyData.notes"
                  placeholder="请输入单据附注信息"
                  @oninputchange="($event) => onInputChange({e: $event, field:'notes'})"
                  @onFocus="onFocus"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="detail-wrp">
          <div class="detail-list-wrp" v-if="goodsList.length > 0">
            <div class="top">
              <div>商品明细 ({{goodsList ? goodsList.length : '0' }})</div>
              <div @click="toSelect">添加商品</div>
            </div>
            <transition-group name="list">
            <div class="list-complete-div" v-for="(item,index) in this.$store.state.invoice.businessGoodsList" :key="item.Id">
                <div class="goods-name">
                <span>{{ item.shortName ? '*' + (item.shortName.split('*').join('')) + '*' + item.goodsName : item.goodsName }}</span>
                <span class="huisuiyunfont" @click="handleDelete(item,index)">{{'\ue61c'}}</span>
              </div>
              <div class="bottom">
                <div class="money">
                   <input type="text" :value="item.price" placeholder="请输入单价" @blur="handleInput($event, item, index, 'price')">
                </div>
                <div class="length">
                  <input type="text" :value="item.quantity" @blur="handleInput($event, item, index, 'quantity')" placeholder="请输入数量">
                </div>
                <div class="sum">
                  <input type="text" :value="item.amountWithTax" @blur="handleInput($event, item, index, 'amountWithTax')" placeholder="请输入总价">
                </div>
              </div>
              <div class="footer">
                <div>
                  <input type="text" :value="item.specification" placeholder="请输入商品规格" @input="handleInput($event, item, index, 'specification')" @focus="handleSpecificationFocus(item,index)">
                </div>
                <div>
                  <InputField
                    v-if="applyData.elementCode === '01'"
                    type="select"
                    :value="item.unit"
                    placeholder="请选择"
                    :align="'right'"
                    :options="getFINISHED_OIL"
                    @oninputchange="(e) => handleInput({ target: { value: e }}, item, index, 'unit')"
                  >
                    <slot slot="button" :name="item.slot" :item="item" v-if="item.slot"></slot>
                  </InputField>
                  <input v-else type="text" :value="item.unit" placeholder="请输入商品单位" @input="handleInput($event, item, index, 'unit')">
                </div>
              </div>
            </div>
          </transition-group>
            <div class="detail-item">
              <div class="select-btn" @click="toSelect">
                <p>添加商品明细</p>
              </div>
            </div>
          </div>
        </div>
        <div class="add-commodity" v-if="goodsList ? goodsList.length === 0 ? true : false : true ">
          <div class="add-commodity-button" @click="toSelect">
            添加商品
          </div>
        </div>
        <SpecificBusiness
          ref="specific-business"
          v-if="applyData.elementCode && applyData.elementCode !== '01'"
          :elementCode="applyData.elementCode"
        />
      </section>
    <div class="remark-wrp">
      <div class="remark-add">
        <div class="btn-wrp">
          <van-button
            :class="['btn', goodsList.length === 0 ? 'dark' : ''].join(' ')"
            :disabled="!goodsList.length > 0"
            @click="submitData"
          >
            确定开票
          </van-button>
        </div>
      </div>
    </div>
    <van-popup
      v-model="qrcodeData.qrcodeShow"
      :close-on-click-overlay="false"
      @close='closeQrcode()'
    >
      <div class="qrcode-modal-wrp">
        <div class="title">
          <p>扫码开票</p>
          <i @click="closeQrcode" class="huixiaopiaofont">&#xe632;</i>
        </div>
        <div class="qrcode-img-wrp">
          <VueQrcode class="qrcode" :value="this.qrcodeData.qrcodeImg" :options="{size:500}"></VueQrcode>
        </div>
        <div class="modal-money-wrp">
          <p>发票金额：</p>
          <p style="color: #4573DE">{{convertNumber(applyData.money)}}</p>
        </div>
        <div class="modal-remark-wrp">
          <p>备注：</p>
          <p>{{applyData.remark}}</p>
        </div>
        <div class="modal-tips">
          <div class="modal-tips-left">提示：</div>
          <div>
            <div>1.二维码有效期为15天</div>
            <div>2.电子发票默认推送至客户指定邮箱</div>
          </div>
        </div>
      </div>
    </van-popup>
    <van-popup
      v-model="showBlankInvoice"
      :close-on-click-overlay="false"
    >
      <div class="showBlankInvoice-wrp">
        <div class="showBlankInvoiceClose">
          <span class="pc-header-title-content">提示</span>
          <i @click="closeBlankInvoicePop" class="huixiaopiaofont">&#xe632;</i>
        </div>
        <div class="showBlankInvoice-content">
          <div>
            <span>空白发票剩余张数：</span>
            <span class="surplusQuantity">{{this.surplusQuantity}}</span>
            <span>张</span>
          </div>
        </div>
      </div>
    </van-popup>
    <van-popup
      v-model="showTaxPlateOnline"
      :close-on-click-overlay="false"
    >
      <div class="showBlankInvoice-wrp">
        <div class="showBlankInvoiceClose">
          <span class="pc-header-title-content">提示</span>
          <i @click="closeTaxPlatePop" class="huixiaopiaofont">&#xe632;</i>
        </div>
        <div class="showBlankInvoice-content">
          <span class="taxplatemsg">{{taxPlateMessage}}</span>
        </div>
      </div>
    </van-popup>
    <van-popup v-model="showInvoiceType" round position="bottom">
      <van-picker
        :default-index="applyData.invoiceTypeDefaultIndex"
        :columns="invoiceTypeList"
        @cancel="showInvoiceType = false"
        @change="(_, value) => onInputChange({e: value, field:'invoiceType'})"
      />
    </van-popup>
    <!-- 特定业务 -->
    <van-popup v-model="showBusinessType" round position="bottom">
      <van-picker
        :default-index="applyData.defaultIndex"
        :columns="businessTypeList"
        @cancel="showBusinessType = false"
        @change="(_, value) => onInputChange({e: value, field:'elementCode'})"
      />
    </van-popup>
    <van-popup
      v-model="showTaxRateWarning"
      :close-on-click-overlay="false"
    >
      <div class="showBlankInvoice-wrp">
        <div class="showBlankInvoiceClose">
          <span class="pc-header-title-content">提示</span>
          <i @click="showTaxRateWarning = false" class="huixiaopiaofont">&#xe632;</i>
        </div>
        <div class="showBlankInvoice-content" style="flex-direction: column">
          <span class="taxplatemsg" v-for="(item, key) in taxRateWarningText" :key="key" style="margin-bottom: 10px">{{item}}</span>
        </div>
        <div class="submit-btn-wrp">
          <van-button
            loading-type="spinner"
            class="submit-btn"
            type="info"
            @click="showTaxRateWarning = false"
            >取消
          </van-button>
          <van-button
            loading-type="spinner"
            class="submit-btn"
            type="info"
            v-if="showContinue"
            @click="taxRateResolve();showTaxRateWarning = false"
            >继续提交
          </van-button>
        </div>
      </div>
    </van-popup>
    <transition name="fade">
    <div class="changer-specification" v-show="show">
      <div class="changer-specification-box">
        <div class="goods-name">
          <div>{{goodsItem.goodsName ? goodsItem.goodsName : '--'}}</div>
          <div class="iconfont" @click="handleClosePopup">{{'\ue607'}}</div>
        </div>
        <div class="goods-specification">
          <van-field
            v-model="goodsItem.specification"
            rows="3"
            autosize
            type="textarea"
            ref="textarea"
            maxlength="80"
            placeholder="请输入规格"
            show-word-limit
          />
        </div>
        <div class="affirm">
          <div class="specification-edit" @click="handleClosePopup">确认</div>
        </div>
      </div>
    </div>
    </transition>
  </div>
</template>

<script>
import {
  Swipe,
  SwipeItem,
  Field,
  CellGroup,
  Popup,
  Notify,
  Toast,
  Button,
  Divider,
  Picker
} from 'vant'
import moment from 'moment'
import {
  ConvertNumber,
  deepCopy,
  onCount,
  remarkLineNumTest,
  cutInvoiceRemark,
  localStorage,
  isEmpty,
  onCheckTaxRate,
  getMixLength,
  cutOutNumber,
  testGoods,
  setWebCache,
  isAllElectric,
  getWebCache,
  CheckBusinessMainInfo
} from '@utils/basicUtil'
import VueQrcode from '@xkeshi/vue-qrcode'
import InputField from '@components/InputField'
import SpecificBusiness from '@components/SpecificBusiness'
import { businessRequest, invoiceRequest } from '@services'
import { InvoiceCal } from '@/utils/invoiceCal'
import { INVOICE_TYPE_MAPPING, SPECIFIC_BUSINESS_OPTIONS, FINISHED_OIL } from '@/assets/config'
export default {
  props: ['loading'],
  data: () => ({
    today: '',
    moneyIptShow: false,
    show: false,
    goodsItem: {},
    pleaseShow: true,
    qrcodeData: {
      qrcodeShow: false,
      qrcodeImg: ''
    },
    specificElementVOs: [],
    detailSum: 0,
    showRemarkModal: false,
    orderTime: '',
    surplusQuantity: 0,
    showBlankInvoice: false,
    showTaxPlateOnline: false,
    showTaxRateWarning: false, // 税率警告提示框
    showContinue: true, // 税率警告提示框
    taxPlateMessage: '',
    innerFlag: 2, // 1内部账号 2外部账号,
    payCodeImg: '',
    // editData: {
    //   money: ''
    // }
    invoiceTypeList: [],
    businessTypeList: [
      '暂未选择',
      '成品油',
      '建筑服务',
      '货物运输服务',
      '不动产销售服务',
      '不动产经营租赁服务',
      '旅客运输服务'
    ],
    showBusinessType: false,
    showInvoiceType: false,
    taxRateWarningText: [],
    taxRateResolve: () => {}
  }),

  watch: {
    applyData (v) {
      console.log(v)
    }
  },
  computed: {
    getFINISHED_OIL () {
      return FINISHED_OIL
    },
    getIsAllElectric () {
      return isAllElectric(this.applyData.invoiceType)
    },
    setNum () {
      return function (money) {
        if (money === '' || money === null) {
          return '0.00'
        }
        let num = money + ''
        let arr = num.split('.')
        if (arr[1]) {
          return Number(arr[1]) < 10 ? Number(arr[1]) + '0' : num
        } else {
          return money + '.00'
        }
      }
    },
    getInvoiceType () {
      return (type) => {
        return INVOICE_TYPE_MAPPING[type]
      }
    },
    getBusinessType () {
      return (type) => {
        const item = SPECIFIC_BUSINESS_OPTIONS.find(i => i.value === type)
        return item ? item.label : ''
      }
    },
    moneyIpt () {
      return this.$refs['moneyIpt']
    },
    goodsList () {
      return this.$store.state.invoice.businessGoodsList
    },
    applyData () {
      return this.$store.state.invoice.businessApplyData
    },
    showTaxSign () {
      // 0 显示
      // 1 不显示。默认所有商品含税
      // 免税政策 也不显示
      return localStorage.get('showTaxSign') === '0'
    },
    companyInfo () {
      return this.$store.state.user.company
    }
  },
  async mounted () {
    if (!localStorage.get('invoiceLimits')) {
      Notify({ type: 'danger', message: '尚未维护开票信息，请前往智能财税平台补充信息~' })
      return this.$router.push('/')
    }
    let invoiceLimits = localStorage.get('invoiceLimits').split(',')
    invoiceLimits = invoiceLimits.sort((a, b) => a - b)
    invoiceLimits.forEach((item) => {
      switch (Number(item)) {
        case 3:
          this.invoiceTypeList.unshift('电子普票直开')
          break
        case 4:
          this.invoiceTypeList.push('电子专票直开')
          break
        case 7:
          this.invoiceTypeList.push('数电普直开')
          break
        case 8:
          this.invoiceTypeList.push('数电专直开')
          break
        default:
          break
      }
    })
    // 只有没找到的时候才去重新赋值
    if (!invoiceLimits.find((item) => (this.applyData.invoiceType + '') === item)) {
      this.changeApply({
        invoiceType: invoiceLimits.find(type => [3, 4, 7, 8].includes(Number(type))) || ''
      })
    }
    let showSum = 0
    this.$store.commit('invoice/changeBusinessGoodsList', [])
    if (sessionStorage.nowGoodsMessage) {
      let Id = 0
      let arr = []
      this.$store.commit('invoice/changeBusinessGoodsList', [...JSON.parse(sessionStorage.nowGoodsMessage)])
      arr = this.$store.state.invoice.businessGoodsList.map((item) => {
        item.Id = Id++
        return item
      })
      this.$store.commit('invoice/changeBusinessGoodsList', [...arr])
    }
    let Id = 0
    let arr = []
    arr = this.$store.state.invoice.businessGoodsList.map((item, index) => {
      showSum += Number(item.amountWithTax) ? Number(item.amountWithTax) : Number(item.price) * Number(item.quantity) || 0
      item.Id = Id++
      return item
    })
    this.$store.commit('invoice/changeBusinessGoodsList', [...arr])
    this.applyData.money = Number(Number(showSum).toFixed(2))
    await this.initToday()
    await this.clearToast()
    await this.initGoods()
    // eslint-disable-next-line new-cap
    this.checkTaxRate = new onCheckTaxRate()
    this.reductionCache(invoiceLimits)
  },
  methods: {
    handleSubstrFn (value) {
      let remarkRule = /[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF][\u200D|\uFE0F]|[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF]|[0-9|*|#]\uFE0F\u20E3|[0-9|#]\u20E3|[\u203C-\u3299]\uFE0F\u200D|[\u203C-\u3299]\uFE0F|[\u2122-\u2B55]|\u303D|[A9|AE]\u3030|\uA9|\uAE|\u3030/ig
      let remark = (value || '').replace(remarkRule, '')
      remark = cutInvoiceRemark(this.applyData.invoiceType, remark)
      return remark
    },
    handleSpecificationFocus (item) {
      this.show = true
      this.goodsItem = item
      setTimeout(() => {
        this.$refs.textarea.focus()
      })
    },
    handleClosePopup () {
      this.show = false
      this.goodsItem = {}
    },
    handleDelete (item, index) {
      let showSum = 0
      this.$store.state.invoice.businessGoodsList.splice(index, 1)
      sessionStorage.nowGoodsMessage = JSON.stringify(this.$store.state.invoice.businessGoodsList)
      sessionStorage.goods = JSON.stringify(this.$store.state.invoice.businessGoodsList)
      this.$store.state.invoice.businessGoodsList.forEach((item, index) => {
        showSum += Number(item.amountWithTax) ? Number(item.amountWithTax) : Number(item.price) * Number(item.quantity) || 0
      })
      this.applyData.money = showSum
    },
    handleInput (e, item, index, field) {
      let newItem = { ...item }
      let value = e.target.value
      let showSum = 0
      newItem[field] = value
      let invoiceCal = new InvoiceCal({ data: { ...newItem, unitPriceWithTax: newItem.price }, invoiceType: this.applyData.invoiceType })
      if (field === 'quantity') {
        invoiceCal.changeQuantityWithTax()
      }
      if (field === 'amountWithTax') {
        invoiceCal.changeAmountWithTax()
      }
      // 含税 unitPriceWithTax
      if (field === 'price') {
        invoiceCal.changeUnitPriceWithTax()
      }
      // 不含税 unitPrice
      if (field === 'unitPrice') {
        invoiceCal.changeUnitPrice()
      }
      if (field === 'amount') {
        invoiceCal.changeAmount()
      }
      newItem = { ...invoiceCal.getResult(), price: invoiceCal.getResult().unitPriceWithTax }
      if (!isAllElectric(this.applyData.invoiceType)) {
        if (newItem.quantity && newItem.quantity.toString().length > 10) {
          const temp = cutOutNumber(newItem.quantity)
          newItem.quantity = temp
        }
        if (newItem.unitPrice && newItem.unitPrice.toString().length > 10) {
          const temp = cutOutNumber(newItem.unitPrice)
          newItem.unitPrice = temp
        }
        if (newItem.price && newItem.price.toString().length > 10) {
          const temp = cutOutNumber(newItem.price)
          newItem.price = temp
        }
      }
      if (field === 'quantity' && newItem.quantity === '') {
        newItem.amountWithTax = ''
        newItem.amount = ''
      }
      let list = this.goodsList
      list.splice(index, 1, newItem)
      this.$store.commit('invoice/changeBusinessGoodsList', list)
      sessionStorage.nowGoodsMessage = JSON.stringify(this.goodsList)
      sessionStorage.goods = JSON.stringify(this.goodsList)
      list.forEach((item, index) => {
        showSum += Number(item.amountWithTax) ? Number(item.amountWithTax) : 0
      })
      this.changeApply({
        money: Number(showSum).toFixed(2)
      })
    },
    convertPrice (price) {
      const priceStr = String(price)
      if (priceStr.length > 15) {
        return priceStr.substr(0, 15)
      }
      return price
    },
    calcAmountWithTax (goods) {
      const {
        taxPre,
        taxSign,
        taxRate = 0,
        price,
        quantity = 1
      } = goods
      const calcTaxRate = onCount.add(1, taxRate)
      const tempAmountWithTax = onCount.mul(price, quantity)
      let amountWithTax
      if (taxPre === 1 && this.showTaxSign) {
        // 不免税且显示是否含税标示
        amountWithTax = onCount.mul(tempAmountWithTax, (taxSign ? 1 : calcTaxRate))
      }
      return (amountWithTax || tempAmountWithTax).toFixed(2)
    },
    async initGoods () {
      if (this.goodsList && this.goodsList.length) { // 有数据就不初始化了
        return
      }
      const data = await invoiceRequest.goods.getGoodsList({ current: this.current, size: this.size, status: 0, existRevenueCode: 1, defaultFlag: 1 })
      if (data.success) {
        if (data.result && data.result.records && data.result.records.length) {
          let arr = data.result.records
          const resArr = arr.map((v, i) => {
            // 免税政策   免税价格
            // 不免税政策 showTaxSign ？原价格 ：含税价格
            // 免税价格：含税标示 ？原价格 / （1+税率） ： 原价格
            // 含税价格：含税标示 ？原价格：原价格*（1+税率）
            v.Id = i++
            const originPrice = v.price
            let resTaxSign = v.taxSign === 1
            let resPrice

            if (!this.showTaxSign && v.taxPre === 1 && !resTaxSign) {
              resTaxSign = true
              resPrice = onCount.mul(originPrice, onCount.add(1, v.taxRate))
            }
            const res = {
              ...v,
              select: true,
              quantity: 1,
              price: this.convertPrice(resPrice || originPrice),
              taxSign: resTaxSign ? 1 : 0
            }
            res.amountWithTax = this.calcAmountWithTax(res)
            this.changeApply({
              money: res.amountWithTax
            })
            return res
          })
          let nowGoodsMessage = []
          if (sessionStorage.nowGoodsMessage) {
            nowGoodsMessage = JSON.parse(sessionStorage.nowGoodsMessage)
          }
          resArr.forEach(i => {
            nowGoodsMessage.push(i)
          })
          sessionStorage.nowGoodsMessage = JSON.stringify(nowGoodsMessage)
          this.changeGoodsList(resArr)
        }
      }
      this.equalMoney()
    },
    sliceStr (text, len) {
      if (text && text.length > len) {
        return text.slice(0, len) + '...'
      } else {
        return text
      }
    },
    clearToast () {
      Toast.clear()
    },
    inputFocus () {
      // if (this.editData.money === '0.00' || this.editData.money === '0' || this.edtiData.money === 0 || this.edtiData.money === 0.00) {
      //   this.$store.commit('business/changeEditDataMoney', '')
      // }
    },
    inputBlur () {
      if (!/^\d+$|^\d*\.\d+$/g.test(this.applyData.money.trim())) {
        if (Number(this.applyData.money) < 0) {
          this.changeApply({
            money: Number(this.applyData.money).toFixed(2)
          })
        } else {
          this.changeApply({
            money: ''
          })
          return Notify({ type: 'danger', message: '请输入正确的金额' })
        }
      }

      this.changeApply({
        money: this.applyData.money.length > 0 ? Number(this.applyData.money).toFixed(2) : this.applyData.money = ''
      })

      this.moneyIptShow = false
      const list = deepCopy(this.goodsList)
      if (!(Array.isArray(list) && list.length === 0)) {
        this.equalMoney()
      }
    },
    calcPriceOrQtyWithAmount (goods) {
      const {
        taxPre,
        taxSign,
        taxRate = 0,
        quantity,
        amountWithTax
      } = goods
      const calcTaxRate = onCount.add(1, taxRate)
      if (quantity) {
        const tempPrice = onCount.div(amountWithTax, quantity)
        let resPrice
        if (taxPre === 1 && this.showTaxSign && !taxSign) {
          // 不免税 && 显示是否含税标示 && 不含税标示
          resPrice = onCount.div(tempPrice, calcTaxRate)
        } else {
          resPrice = tempPrice
        }
        return resPrice
      }
    },
    equalMoney () {
      const arr = deepCopy(this.goodsList)
      if (arr.length === 0) {
        return
      }
      let originalMoney = arr.reduce((sum, item) => sum + Number(item.amountWithTax), 0).toFixed(2)
      // 按照比例粗略计算
      const calcArr = arr.map((v, i) => {
        const originalGoodsItem = deepCopy(v)
        const calcRatio = onCount.div(Number(originalGoodsItem.amountWithTax), originalMoney).toFixed(4)
        return {
          ...originalGoodsItem,
          amountWithTax: arr.length > 1 ? onCount.mul(Number(this.applyData.money), calcRatio).toFixed(2) : this.applyData.money
        }
      })
      const calcMoney = calcArr.reduce((sum, item) => sum + Number(item.amountWithTax), 0).toFixed(2)
      const calcResDiff = Number(onCount.sub(Number(this.applyData.money), Number(calcMoney)))
      if (calcResDiff >= 0) {
        let lastGoods = calcArr[calcArr.length - 1]
        // 最后一项加上calcResDiff
        if (isEmpty(lastGoods.amountWithTax)) {
          lastGoods.amountWithTax = (Number(lastGoods.amountWithTax) + calcResDiff).toFixed(2)
        }
      } else {
        // 最大amount项减去calcResDiff
        let indexOfMaxGoods = 0
        // eslint-disable-next-line no-return-assign
        calcArr.reduce((a, c, i) => Number(c.amountWithTax) > a ? (indexOfMaxGoods = i, Number(c.amountWithTax)) : a, 0)
        calcArr[indexOfMaxGoods].amountWithTax = Number(onCount.add(Number(calcArr[indexOfMaxGoods].amountWithTax), calcResDiff)).toFixed(2)
      }
      console.log(calcArr)
      const resGoodsList = calcArr.map((item) => {
        return {
          ...item,
          price: this.calcPriceOrQtyWithAmount(item) || null
        }
      })
      console.log(resGoodsList)
      this.changeGoodsList(resGoodsList)
    },
    async submitData () {
      if (
        [7, 8].includes(this.applyData.invoiceType) &&
        this.applyData.elementCode &&
        this.applyData.elementCode !== '01' &&
        this.$refs['specific-business']
      ) {
        const flag = this.$refs['specific-business'].handleCheck()
        if (!flag) return
        this.specificElementVOs = this.$refs['specific-business'].specificElementVOs
      }
      if (this.applyData.money.length < 1) {
        return Notify({ type: 'danger', message: '请先填写金额' })
      } else if (!this.goodsList.length) {
        return Notify({ type: 'danger', message: '请选择商品' })
      }
      if (this.applyData.externalDocumentNo && getMixLength(this.applyData.externalDocumentNo) > 40) {
        return Notify({ type: 'danger', message: '订单编号长度不能超过20个汉字或40个字符' })
      }
      if (this.applyData.notes && getMixLength(this.applyData.notes) > 200) {
        return Notify({ type: 'danger', message: '附注长度不能超过100个汉字或200个字符' })
      }
      await this.onCheckTaxRate()
      await this.onCheckImmediateLevyRefund()
      const details = deepCopy(this.goodsList)
      try {
        if (!testGoods({ list: details, invoiceType: this.applyData.invoiceType })) {
          return
        }
      } catch (error) {
      }
      try {
        if ([7, 8].includes(this.applyData.invoiceType)) {
          const check = new CheckBusinessMainInfo({})
          check.remark({ value: this.applyData.remark })
          details.forEach(i => check.unitPriceWithTax(i.price))
          details.forEach(i => check.unitPrice(i.unitPrice))
          details.forEach(i => check.quantity(i.quantity))
        }
      } catch (error) {
        Notify({ type: 'danger', message: error.message })
        return
      }
      this.basicSubmitData()
    },
    onCheckTaxRate () {
      // 添加小规模纳税人校验
      const arr = deepCopy(this.goodsList)
      const invoiceType = this.applyData.invoiceType
      const nature = this.companyInfo.type
      return new Promise(async (resolve) => {
        const result = await this.checkTaxRate.check({ nature, details: arr, invoiceType })
        if (result.length) {
          this.showTaxRateWarning = true
          this.showContinue = true
          this.taxRateWarningText = result
          this.taxRateResolve = resolve
        } else {
          resolve(true)
        }
      })
    },
    onCheckImmediateLevyRefund () {
      // 添加即征即退商品类型校验，不能混开
      const arr = deepCopy(this.goodsList)
      return new Promise(async (resolve) => {
        const result = await this.checkTaxRate.checkImmediateLevyRefund({ details: arr })
        if (result.length) {
          this.showTaxRateWarning = true
          this.showContinue = false
          this.taxRateWarningText = result
          this.taxRateResolve = resolve
        } else {
          resolve(true)
        }
      })
    },
    async basicSubmitData () {
      let postData = {}
      const arr = deepCopy(this.goodsList)
      arr.forEach((v, i) => {
        v.price = this.convertPrice(v.price)
        v.unitPriceWithTax = v.price
      })
      postData.details = arr
      postData.amountWithTax = this.applyData.money
      postData.remark = this.applyData.remark
      postData.notes = this.applyData.notes
      postData.externalDocumentNo = this.applyData.externalDocumentNo
      postData.invoiceType = this.applyData.invoiceType
      postData.elementCode = this.applyData.elementCode
      postData.specificElementVOs = this.specificElementVOs
      const newData = await businessRequest.qrcode.createInvoice({ ...postData, settlementSource: 7 })
      this.orderTime = moment(newData.result.drewDate).format('YYYY-MM-DD HH:mm:ss')
      if (newData.success) {
        if (newData.result) {
          let codeValidTime = newData.result.lostTime || ''
          this.$router.push(`/invoice/business/show?id=${newData.result.settlementId}&prescription=${JSON.stringify(codeValidTime)}&infoId=${newData.result.id}`)
        }
      } else {
        if (newData.success === false) {
          Notify({ type: 'danger', message: newData.message })
        }
      }
      await Toast.clear()
      sessionStorage.clear()
    },
    initToday () {
      this.today = moment().format('YYYY/MM/DD')
    },
    clearMoney () {
      this.changeApply({
        money: 0
      })
      sessionStorage.removeItem('nowGoodsMessage')
      sessionStorage.removeItem('goods')
      this.changeGoodsList([])
    },
    changeApply (params) {
      this.$store.commit('invoice/changeBusinessApplyData', {
        data: params
      })
    },
    changeGoodsList (goodsList) {
      this.$store.commit('invoice/changeBusinessGoodsList', goodsList)
    },
    convertNumber (data) {
      return ConvertNumber(data)
    },
    moneyValueHandle () {
      if (this.applyData.money === '0.00' || this.applyData.money === '0' || this.applyData.money === 0 || this.applyData.money === 0.00) {
        this.applyData.money = ''
      }
      this.moneyIptShow = true
      setTimeout(() => {
        this.moneyIpt.focus()
      })
      // let screenHeight = document.body.offsetHeight
    },
    toSelect () {
      /**
       * 第一步: 在跳转之前需要去看ref中的特定业务
       * 第二步: 存在就将值存储在浏览器缓存中，方式回来的时候拿不到
       */
      if (this.$refs['specific-business']) {
        setWebCache('specificElementVOs', this.$refs['specific-business'].specificElementVOs)
      }
      this.$router.push(`/invoice/goods-list?source=business`)
    },
    closeQrcode () {
      this.qrcodeData.qrcodeShow = false
      this.changeApply({
        remark: ''
      })
    },
    closeBlankInvoicePop () {
      this.showBlankInvoice = false
    },
    closeTaxPlatePop () {
      this.showTaxPlateOnline = false
    },
    resetScrollTop () {
      setTimeout(() => {
        var scrollHeight = document.documentElement.scrollTop || document.body.scrollTop || 0
        window.scrollTo(0, Math.max(scrollHeight - 1, window.innerHeight))
      }, 100)
    },
    scrollToInput () {
      this.resetScrollTop()
    },
    onFocus () {
      this.scrollToInput()
    },
    onResetBlur () {
      this.resetScrollTop()
    },
    reductionCache (invoiceLimits) {
      const invoiceType = getWebCache('businessIndexInvoiceType')
      // 如果缓存存在，并且在配置项里也找到了这个对应的发票类型才还原缓存
      if (invoiceType && invoiceLimits.find(i => Number(i) === Number(invoiceType))) {
        if (getWebCache('businessIndexDefaultIndex')) this.changeApply({ defaultIndex: getWebCache('businessIndexDefaultIndex') })
        if (getWebCache('businessIndexElementCode')) this.changeApply({ elementCode: getWebCache('businessIndexElementCode') })
        this.changeApply({ invoiceType: invoiceType })
        this.changeApply({ invoiceTypeDefaultIndex: invoiceLimits.findIndex(i => Number(i) === Number(invoiceType)) })
      } else {
        this.changeApply({ defaultIndex: 0 })
        this.changeApply({ elementCode: '' })
        this.changeApply({ invoiceTypeDefaultIndex: 0 })
      }
    },
    onInputChange ({ e, field }) {
      if (field === 'remark') {
        let remark = e || ''
        if (!remarkLineNumTest(remark, this.applyData.invoiceType)) {
          return
        }
        this.changeApply({
          remark
        })
      }
      if (field === 'externalDocumentNo') {
        let externalDocumentNo = e
        this.changeApply({
          externalDocumentNo
        })
      }
      if (field === 'notes') {
        let notes = e
        this.changeApply({
          notes
        })
      }
      if (field === 'invoiceType') {
        this.showInvoiceType = false
        if (!['数电普直开', '数电专直开'].includes(e)) {
          this.changeApply({
            elementCode: ''
          })
          setWebCache('businessIndexDefaultIndex', 0)
          setWebCache('businessIndexElementCode', '')
        }
        let invoiceType = null
        if (e === '电子专票直开') {
          invoiceType = 4
        } else if (e === '电子普票直开') {
          invoiceType = 3
        } else if (e === '数电普直开') {
          invoiceType = 7
        } else if (e === '数电专直开') {
          invoiceType = 8
        }
        setWebCache('businessIndexInvoiceType', invoiceType)
        this.changeApply({
          invoiceType: invoiceType
        })
        this.changeApply({
          invoiceTypeDefaultIndex: this.invoiceTypeList.findIndex(i => i === e)
        })
      }
      if (field === 'elementCode') {
        this.showBusinessType = false
        const item = SPECIFIC_BUSINESS_OPTIONS.find(i => i.label === e)
        const defaultIndex = SPECIFIC_BUSINESS_OPTIONS.findIndex(i => i.label === e)
        this.changeApply({
          defaultIndex: defaultIndex
        })
        this.changeApply({
          elementCode: item ? item.value : ''
        })
        setWebCache('businessIndexDefaultIndex', defaultIndex)
        setWebCache('businessIndexElementCode', item ? item.value : '')
      }
    }
  },
  components: {
    [SwipeItem.name]: SwipeItem,
    [Swipe.name]: Swipe,
    [Field.name]: Field,
    [CellGroup.name]: CellGroup,
    [Popup.name]: Popup,
    [Button.name]: Button,
    [Divider.name]: Divider,
    [Picker.name]: Picker,
    SpecificBusiness,
    VueQrcode,
    InputField
  }
}
</script>

<style lang="less" scoped src="./style.less"/>
